import { createApiCall } from 'lib/base';

interface CreateFundManagerBody {}

const CREATE_FUND_MANAGER = 'CREATE_FUND_MANAGER';

export const createFundManagerApi = createApiCall<
  CreateFundManagerBody & { payload: any }
>(CREATE_FUND_MANAGER, ({ payload }) => ({
  endpoint: `api/admin/fund-managers`,
  method: 'POST',
  body: payload,
}));

export default createFundManagerApi;
